import RESEND_SIGN_UP_EMAIL from './resendSignUpEmail.gql';
import UPDATE_EMAIL from './updateEmail.gql';
import VALIDATE_VERIFICATION_CODE from './validateVerificationCode.gql';

export {
  RESEND_SIGN_UP_EMAIL,
  UPDATE_EMAIL,
  VALIDATE_VERIFICATION_CODE,
};
